export const en = {
    'home': 'Home',
    'tours': 'Tours',
    'services' : 'Services',
    'blogs' : 'Blog',
    'about' : 'About',
    'contact' : 'Contact',
    'to_usa' : 'to the United States of America',
    'to_thailand' : "in Thailand",
    'to_europe' : 'in Europe',
    'to_dubai' : 'in Dubai',
    'to_egypt' : 'in Egypt',
    "to_malasia" : 'in Malaysia',
    'home_icon1' : 'Amazing Travel',
    'home_icon1-txt' : 'Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language  ocean. A  small river named Duden flows by their place and supplies',
    'home_icon2' : "Our Cruises",
    'home_icon2-txt' : "Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies",
    'home_icon3' : "Book Your Trip",
    'home_icon3-txt' : "Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies",
    'home_icon4' : "Nice Support",
    'home_icon4-txt' : "Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies",
    'home_cards-title' : "Tours around the world",
    'home_cards-txt' : "Budget Tours / Individual Tours / Family Tours",

}                                                                                             





